import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CONSTS, DELAY_OPTIONS } from './edi-setting.constants';

@Component({
  selector: 'app-edi-setting',
  templateUrl: './edi-setting.component.html',
  styleUrl: './edi-setting.component.scss',
  standalone: false,
})
export class EdiSettingComponent {
  @Input({ required: true }) form!: FormGroup;

  readonly CONSTANTS = CONSTS;
  readonly OPTIONS = DELAY_OPTIONS;

  updateValue($event: boolean) {
    this.form.get('ediDelay')?.setValue($event);
  }
}
